module.exports = __webpack_public_path__ + "img/28-4.d56ee74e.jpg";